export enum AnnualPlanRole {
  PlanAdministrator = 'Plan Administrator',
  PlanContributor = 'Plan Contributor',
  PlanReviewer = 'Plan Reviewer',
  PlanReviewerReadOnly = 'Plan Reviewer Read Only'
}
